import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import { withStyles } from '@material-ui/styles';

import { compose } from 'redux';
import withScrollListener from "../../../../../hocs/with_scroll_listener.js.jsx";
import withShowModal from '../../../../../hocs/with_show_modal.js.jsx';

import usePrevious from "../../../../../hooks/use_previous.js.jsx";

import NavigationTabContent from "../../../components/navigation_tab_content.js.jsx";

import TableView  from "../../../../../base/table/table_view.js.jsx";
import FormFields from "../../../../../base/form/form_fields.js.jsx";

import { ClearItemValue } from "../../../../../base/inputs/constants.js.jsx";

import pageStyles from "../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../base_info_page.js.jsx";

import { DownloadableSubscriberModel } from "../../../../../models/downloadables/downloadable_subscribers_model.js.jsx";
import ListSubscribersUseCase from "../../../../../use_cases/admin/downloadables/subscribers/list_subscribers_use_case";

const styles = theme => ({
  root: {
    position: "relative"
  },
  filters: {
    marginBottom: "15px"
  }
});


const DownloadableSubscribersTab = forwardRef((props, ref) => {

  const pageSize = 50;

  const {
    classes,
    downloadable = {},
    onScrollToEndProcessed,
    onDataLoaded,
    onChangeFilter,
    visible
  } = props;

  const [subscribers, setSubscribers] = useState([]);
  const [onceLoaded, setOnceLoaded] = useState(false);
  const [filterData, setFilterData] = useState(props.filterData);

  const previousSubscribers = usePrevious(subscribers);

  const internalRef = useRef();

  useEffect(() => {
    internalRef.current = {
      paginationInfo:  {
        page: 1,
        perPage: pageSize,
        hasMore: true
      }
    }
  }, []);

  useEffect(() => {
    if(onceLoaded) {
      return;
    }
    if(!visible) {
      return;
    }
    loadSubscribers();
  }, [visible]);

  useEffect(() => {
    const { current : { paginationInfo } } = internalRef;

    let prevCount = (previousSubscribers || []).length;
    let currCount = subscribers.length;
    if(prevCount < currCount) {
      onDataLoaded(paginationInfo.hasMore);
    }
  }, [subscribers]);

  useEffect(() => {
    internalRef.current = {
      paginationInfo:  {
        page: 1,
        perPage: pageSize,
        hasMore: true
      }
    }
    loadSubscribers({forceReload: true});
  }, [filterData]);

  const loadSubscribers = ({forceReload = false} = {}) => {
    if(!visible) {
      return;
    }

    const { current : { paginationInfo } } = internalRef;

    const params = {
      ...paginationInfo,
      ...filterData
    }

    if(ListSubscribersUseCase.cancel) {
      ListSubscribersUseCase.cancel();
    }

    return ListSubscribersUseCase.execute(downloadable.id, params)
      .then((result) => {
        const { data: { list, paginationInfo : newPaginationInfo } } = result;

        const processedList = list.map((subscriber) => {
          return subscriber;
        })

        let newList = subscribers.concat(processedList);
        if(forceReload) {
          newList = processedList;
        }

        setOnceLoaded(true);
        internalRef.current.paginationInfo = newPaginationInfo;
        onScrollToEndProcessed(paginationInfo.hasMore);

        setSubscribers(newList);
      })
      .catch((result) => {

      });
  }

  useImperativeHandle(ref, () => ({

    onScrolledToEnd() {
      const { current : { paginationInfo } } = internalRef;
      if(!paginationInfo.hasMore) {
        return;
      }
      const { page } = paginationInfo;

      let newPaginationInfo = {
        ...paginationInfo,
        page: page + 1,
      };
      internalRef.current.paginationInfo = newPaginationInfo

      loadSubscribers();
    }
  }));

  const onChangeFilterField = (newItem, field, newValue) => {
    let value = newValue;
    let fieldName = field.name;
    if(field.type === "enum" && value === ClearItemValue) {
      value = undefined;
    }
    if(field.type === "model") {
      fieldName = field.foreignKey;
      value = newItem[fieldName];
    }
    const newFilterData = {
      ...filterData,
      [fieldName]: value
    };
    setFilterData(newFilterData);
    onChangeFilter(fieldName, value);

  }

  const columnsWhiteList = ["email", "createdAt"];
  const columns = DownloadableSubscriberModel.listFields().filter(c => columnsWhiteList.includes(c.name));

  return (
    <NavigationTabContent visible = { visible } >
      <div className = { classes.root } >
        <div className = { classes.filters } >
          <FormFields formFields = { DownloadableSubscriberModel.listFilters() }
                      item = { filterData }
                      onItemChange = { onChangeFilterField }
                      defaultWeight = { 3 } />
        </div>
        <div className = { classes.list } >
          <TableView columns = { columns }
                     items = { subscribers }
                     onClickRow = {() => {}} />
        </div>
      </div>
    </NavigationTabContent>
  );
});

DownloadableSubscribersTab.defaultProps = {
}

export default compose(
  withShowModal,
  withScrollListener,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(DownloadableSubscribersTab);
